define('glu/core/internal/masking',['require','../../$','../../util','../../number','jquery-mask'],function(require) {
    'use strict';

    var $ = require('../../$'),
        util = require('../../util'),
        number = require('../../number');

    require('jquery-mask');

    /**
     * @param customMaskPattern {String}
     */
    $.fn.maskNumeric = function(customMaskPattern) {
        var mask = 'SDDDDDDDDDC0D'; // Default mask - up to 9,999,999,999.99
        if (!util.isEmpty(customMaskPattern) && util.isString(customMaskPattern)) {
            mask = customMaskPattern.toUpperCase();
        }

        return $.fn.mask.apply(this, [mask, {
            translation: {
                'S': {
                    pattern: /^[-+]/,
                    optional: true
                },
                'C': {
                    pattern: /\./,
                    options: true
                },
                'D': {
                    pattern: /[0-9]/,
                    optional: true
                }
            }
        }]);
    };

    $.fn.maskAmount = function() {
        // Generate mask according to user localization
        var decimal = number.languageData().delimiters.decimal,
            thousands = number.languageData().delimiters.thousands,
            mask = '#' + thousands + '##0' + decimal + '00';

        return $.fn.mask.apply(this, [mask, {
            onKeyPress: function(value, e, field) {
                if (value.length < 2) {
                    value = '0' + decimal + '0' + +value;
                } else if (value.length < 3) {
                    value = '0' + decimal + value;
                } else {
                    //will format value according to user localization
                    value = number(value).format('0,0.00');
                }
                field.val(value);
            },
            selectOnFocus: true,
            reverse: true
        }]);
    };

});

